var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCreditFlashOrange = function SvgIconCreditFlashOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M9.487.5a.25.25 0 0 0-.192.107l-5.75 8.249a.25.25 0 0 0 .205.393h3.979L7.25 15.23c-.019.253.307.37.454.163l5.75-8.25a.25.25 0 0 0-.204-.392H9.27L9.75.769A.25.25 0 0 0 9.487.5"
  })));
};
export default SvgIconCreditFlashOrange;